<template>
	<v-dialog v-model="ui.dialog" persistent max-width="600">
		<v-card
			:class="['pt-0', $vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-4']"
			:loading="ui.loading"
		>
			<v-card-title>
				Actualización de estado
			</v-card-title>

			<v-card-subtitle>
				{{
					`Actualización de estado para: ${data.salesorders.length} ordenes de venta.`
				}}
			</v-card-subtitle>

			<v-card-text class="pb-0 pt-0">
				<v-row>
					<v-col cols="12" class="d-flex flex-column pb-0">
						<div class="d-flex align-center">
							Las ordenes de venta cambiarán al siguiente estado:
							<v-chip class="ml-1" color="primary" small
								>recibido</v-chip
							>
						</div>

						<v-switch
							v-model="layout.notify"
							inset
							label="Notificar esta acción a los clientes via correo electrónico."
						></v-switch>

						<v-alert type="info" outlined v-if="layout.notify">
							¡Atención! Solo se podrá notificar al cliente si
							este ya se encuentra registrado.
						</v-alert>
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions class="d-flex justify-end">
				<v-btn
					color="primary"
					text
					:disabled="ui.loading"
					@click="ui.dialog = false"
				>
					Cancelar
				</v-btn>
				<v-btn color="primary" @click="update()" :loading="ui.loading">
					Enviar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/main";
import SalesOrder from "@/clas/SalesOrder";

export default {
	name: "StatusUpdate",

	data() {
		return {
			data: {
				salesorders: [],
			},

			layout: {
				notify: true,
				status_id: 2,
			},

			ui: {
				dialog: false,

				loading: false,
			},
		};
	},

	mounted() {
		EventBus.$on("SalesOrdersStatusUpdate", (salesorders) => {
			this.data.salesorders = salesorders;

			this.ui.dialog = true;
		});
	},

	methods: {
		async update() {
			try {
				this.ui.loading = true;

				let payload = [];

				for (var i in this.data.salesorders) {
					let salesOrder = new SalesOrder(this.data.salesorders[i]);

					await salesOrder.statusUpdate(this.layout);
				}

				this.ui.dialog = false;

				EventBus.$emit("SalesOrdersStatusUpdated");
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.loading = false;
			}
		},
	},
};
</script>

<style lang="css" scoped></style>
